import { useQuery } from "@apollo/client";
import { Link } from "react-router";
import { SwiperSlide } from "swiper/react";
import { GetObjects } from "../../api/objects";
import Image from "../../components/core/Image/Image";
import Loader from "../../components/core/Loader/Loader";
import Slider from "../../components/core/Slider/Slider";
import Text from "../../components/core/Text/Text";
import styles from "./Objects.module.scss";

const Objects = () => {
  const { data, loading } = useQuery(GetObjects, {
    variables: {
      take: 50,
      hydrateRelationships: true,
      where: {
        images: {
          some: {
            name: {
              not: {
                equals: "",
              },
            },
          },
        },
        typ: {
          some: {
            id: {
              in: ["clo7w2i100vmkpz7lnrjuigjs"],
            },
          },
        },
      },
    },
  });

  return (
    <div className={styles.wrapper}>
      {!loading && (
        <Slider
          spaceBetween={40}
          centerInsufficientSlides
          className={styles.slider}
          items={4}
          navigation
          classNamePrevButton={styles.prevButton}
          classNameNextButton={styles.nextButton}
          singleMobileItem
        >
          {data?.items?.map((object) => (
            <SwiperSlide key={object.id} className={styles.slide}>
              <Link to={`/browse/objects/${object.id}`}>
                <Image
                  src={object.images?.[0]?.bild?.url ?? ""}
                  className={styles.image}
                />
                <Text size={3} text={object.title} className={styles.title} />
                <Text
                  size={5}
                  text={object.authorPerson
                    ?.map((x) => `${x.givenName} ${x.familyName}`)
                    .join(", ")}
                  className={styles.author}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Slider>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default Objects;
